import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
export interface ProductSaleListTableStateState {
    TableState: string;
}

// Define the initial state using that type
const initialState: ProductSaleListTableStateState = {
    TableState: JSON.stringify({ sorting: { sortModel: [{ field: "scoreDate", sort: "desc" }] } }),
};

export const productSaleListTableStateSlice = createSlice({
    name: "productSaleListTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateProductSaleGridState: (state, action: PayloadAction<string | null>) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateProductSaleGridState } = productSaleListTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const ProductSaleListTableState = (state: RootState) => state;
export default productSaleListTableStateSlice.reducer;
